export function matchScannedBox(scannedValue, boxes) {
  const value = (scannedValue || '').toString().trim().toLowerCase();
  if (!value || !Array.isArray(boxes)) return {isBoxScan: false};

  const matchedIndex = boxes.findIndex(
    box => box && box.barcode && box.barcode.toString().trim().toLowerCase() === value
  );
  if (matchedIndex === -1) return {isBoxScan: false};

  return {isBoxScan: true, matchedIndex};
}
